import classNames from 'classnames';
import * as React from 'react';

import { staticPageConstants } from '../../../../common/constants/staticPageConstants';

import ButtonTabsContent from './ButtonTabsContent';
import ButtonTabsNav     from './ButtonTabsNav';

const ButtonTabs = function(props) {
  const {
          content,
          label,
          nav,
          renderStaticSection,
          style,
          tabsLevel,
        } = props;

  const [activeTab, setActiveTab] = React.useState(0);
  const [child, setChild]         = React.useState({});
  const [isOpen, setIsOpen]       = React.useState(false);

  const childActiveTab = React.useMemo(() => {
    return child[activeTab] || 0;
  }, [activeTab, child]);
  const childTabs      = React.useMemo(() => {
    const [block = {}] = content[activeTab] ?? [];

    if (
      style !== staticPageConstants.COMPONENTS.BUTTON_TABS.SETTINGS.STYLE.SELECT ||
      block.DATA?.STYLE !== staticPageConstants.COMPONENTS.BUTTON_TABS.SETTINGS.STYLE.SELECT ||
      block.COMPONENT !== staticPageConstants.COMPONENTS.BUTTON_TABS.LABEL
    ) {
      return;
    }

    return {
      label: block.DATA.LABEL,
      nav:   block.DATA.NAV,
    };
  }, [activeTab, content]);
  const level          = React.useMemo(() => {
    return tabsLevel + 1;
  }, [tabsLevel]);

  const changeState    = React.useCallback((open) => {
    if (child[activeTab] !== open) {
      setChild({
        ...child,
        [activeTab]: open,
      });
    }
  }, [activeTab, child]);
  const changeTab      = React.useCallback((index) => {
    if (activeTab !== index) {
      setActiveTab(index);
    }
  }, [activeTab]);
  const changeChildTab = React.useCallback((index) => {
    if (typeof child[activeTab] === 'undefined' || child[activeTab] !== index) {
      setChild({
        ...child,
        [activeTab]: index,
      });
    }
  }, [activeTab, child]);
  const render         = React.useCallback((block, index, level) => {
    return renderStaticSection({
      ...block,
      DATA: {
        ...block.DATA,
        TABS_LEVEL: level,
      },
    }, index);
  }, [renderStaticSection]);

  if (childTabs) {
    return (
      <div className={classNames('tabbable static', style)}>
        <div className={'top'}>
          <ButtonTabsNav
            active={activeTab}
            changeState={setIsOpen}
            changeTab={changeTab}
            label={label}
            nav={nav}
            open={isOpen}
            style={style}
          />
          <ButtonTabsNav
            active={childActiveTab}
            changeState={changeState}
            changeTab={changeChildTab}
            label={childTabs.label}
            nav={childTabs.nav}
            open={child[activeTab] || false}
            style={style}
          />
        </div>
        <ButtonTabsContent active={activeTab}>
          {content.map((tab, index) => {
            return (
              <div key={index}>
                {tab?.map((block, blockIndex) => {
                  if (index === activeTab && blockIndex === 0) {
                    return block.DATA.CONTENT[childActiveTab].map((block, blockIndex) => {
                      return render(block, blockIndex, level + 1);
                    });
                  }

                  return render(block, blockIndex, index === activeTab ? level + 1 : level);
                })}
              </div>
            );
          })}
        </ButtonTabsContent>
      </div>
    );
  }

  return (
    <div className={classNames('tabbable static', style)}>
      <div className={'top'}>
        <ButtonTabsNav
          active={activeTab}
          changeState={setIsOpen}
          changeTab={changeTab}
          label={label}
          nav={nav}
          open={isOpen}
          style={style}
        />
      </div>
      <ButtonTabsContent active={activeTab}>
        {content.map((tab, index) => {
          return (
            <div key={index}>
              {tab?.map((block, blockIndex) => {
                return render(block, blockIndex, level);
              })}
            </div>
          );
        })}
      </ButtonTabsContent>
    </div>
  );
};

export default ButtonTabs;